export interface FilterItem {
    id: string;
    name: string;
    cssBackground: string;
    iconPath: string;
    selected: boolean;
    filterType: FilterType;
    analyticsValue: string;
}

export interface FilterModal {
    apply?: boolean;
    filters?: Array<FilterItem>;
    clearAllFilters?: boolean;
}

export enum FilterType {
    productFamilies = 'productFamilies',
    colors = 'colors',
    muster = 'muster',
}
